import React, { useMemo } from "react";
import { FormProvider } from "react-hook-form";

import FormInputs from "./FormInputs";
import useDownloadPDFForm from "./useDownloadPDFForm";

import { classNameGenerator } from "@/utils";

import styles from "./DownloadPDFForm.module.scss";

interface DownloadPDFFormProps {
  isLoading: boolean;
  methods: any;
  handleBlur: () => void;
  onSubmit: () => void;
}

const DownloadPDFForm: React.FC<DownloadPDFFormProps> = ({
  isLoading,
  methods,
  handleBlur,
  onSubmit,
}) => {
  const formData = useMemo(
    () => ({
      showNameField: true,
      namePlaceholder: "Your Name",
      showPhoneField: true,
      phonePlaceholder: "Your Phone",
      showEmailField: true,
      emailPlaceholder: "Your email address",
    }),
    []
  );

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = methods;

  const cls = classNameGenerator(styles);

  return (
    <FormProvider {...methods}>
      <form className={cls("form")} onSubmit={handleSubmit(onSubmit)}>
        <FormInputs
          {...formData}
          control={control}
          isLoading={isLoading}
          formError={errors?.formError}
        />
      </form>
    </FormProvider>
  );
};

export default DownloadPDFForm;
